/** @format */

import React from "react";
import { PreviousIcon, SkipIcon } from "./IconComponents";

const Pagination = ({ activePage, totalPages, onPageChange }) => {
  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      onPageChange(page);
    }
  };

  const goToPreviousPage = () => {
    const previousPage = activePage === 1 ? totalPages : activePage - 1;
    handlePageChange(previousPage);
  };

  const goToNextPage = () => {
    const nextPage = activePage === totalPages ? 1 : activePage + 1;
    handlePageChange(nextPage);
  };


  return (
    <ul className="flex items-center justify-center mt-4">
      <li>
        <button
          className={`flex items-center px-3 py-1 ${activePage === 1
              ? 'text-disabled cursor-not-allowed'
              : 'text-enabled-btn cursor-pointer'
            } text-xs md:text-sm font-normal`}
          onClick={goToPreviousPage}
          disabled={activePage === 1}
        >
          <PreviousIcon className="pe-1 w-3" /> Previous
        </button>
      </li>
      {Array.from({ length: totalPages }, (_, index) => index + 1).map(
        (page) => (
          <li key={page}>
            <button
              className={`px-3 py-1 ${page === activePage
                  ? "bg-enabled-btn text-white text-xs md:text-sm font-normal"
                  : ""
                }`}
              onClick={() => onPageChange(page)}
            >
              {page}
            </button>
          </li>
        )
      )}
      <li>
        <button
          className={`flex items-center px-3 py-1 ${activePage === totalPages
              ? 'text-disabled cursor-not-allowed'
              : 'text-enabled-btn cursor-pointer'
            } text-xs md:text-sm font-normal`}
          onClick={goToNextPage}
          disabled={activePage === totalPages}
        >
          Next <SkipIcon className="ps-1" />
        </button>
      </li>
    </ul>
  );
};

export default Pagination;



















// import React from "react";
// import { PreviousIcon, SkipIcon } from "./IconComponents";

// const Pagination = ({ activePage, totalPages, onPageChange }) => {
//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       onPageChange(page);
//     }
//   };

//   const goToPreviousPage = () => {
//     const previousPage = activePage === 1 ? totalPages : activePage - 1;
//     handlePageChange(previousPage);
//   };

//   const goToNextPage = () => {
//     const nextPage = activePage === totalPages ? 1 : activePage + 1;
//     handlePageChange(nextPage);
//   };
  

//   return (
//     <ul className="flex items-center justify-center mt-4">
//       <li>
//         <button
//           className="flex items-center px-3 py-1 text-disabled text-xs md:text-sm font-normal cursor-pointer"
//           onClick={goToPreviousPage}
//           disabled={activePage === 1}
//         >
//           <PreviousIcon className="pe-1 w-3" /> Previous
//         </button>
//       </li>
//       {Array.from({ length: totalPages }, (_, index) => index + 1).map(
//         (page) => (
//           <li key={page}>
//             <button
//               className={`px-3 py-1 ${
//                 page === activePage
//                   ? "bg-enabled-btn text-white text-xs md:text-sm font-normal"
//                   : ""
//               }`}
//               onClick={() => onPageChange(page)}
//             >
//               {page}
//             </button>
//           </li>
//         )
//       )}
//       <li>
//         <button
//           className="flex items-center px-3 py-1 text-enabled-btn text-xs md:text-sm font-normal cursor-pointer"
//           onClick={goToNextPage}
//           disabled={activePage === totalPages}
//         >
//           Next <SkipIcon className="ps-1" />
//         </button>
//       </li>
//     </ul>
//   );
// };

// export default Pagination;






// import React from "react";
// import { PreviousIcon, SkipIcon } from "./IconComponents";

// const Pagination = ({ activePage, totalPages, onPageChange }) => {
//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       onPageChange(pageNumber);
//     } else if (pageNumber < 1) {
//       onPageChange(1);
//     } else if (pageNumber > totalPages) {
//       onPageChange(1);
//     }
//   };

//   const renderPageNumbers = () => {
//     const pageNumbers = [];
//     for (let i = 1; i <= totalPages; i++) {
//       pageNumbers.push(i);
//     }
//     return pageNumbers;
//   };

//   return (
//     <ul className="flex items-center justify-center mt-4">
//       <li>
//         <button
//           className="flex items-center px-3 py-1 text-disabled text-xs md:text-sm font-normal cursor-pointer"
//           onClick={() => handlePageChange(activePage - 1)}
//           disabled={activePage === 1}
//         >
//           <PreviousIcon className="pe-1 w-3" /> Previous
//         </button>
//       </li>
//       {renderPageNumbers().map((page, index) => (
//         <li key={index}>
//           <button
//             className={`px-3 py-1 ${page === activePage
//               ? "bg-enabled-btn text-white text-xs md:text-sm font-normal"
//                 : ""
//               }`}
//             onClick={() => handlePageChange(page)}
//           >
//             {page}
//           </button>
//         </li>
//       ))}
//       <li>
//         <button
//           className="flex items-center px-3 py-1 text-enabled-btn text-xs md:text-sm font-normal cursor-pointer"
//           onClick={() => handlePageChange(activePage + 1)}
//           disabled={activePage === totalPages}
//         >
//           Next <SkipIcon className="ps-1" />
//         </button>
//       </li>
//     </ul>
//   );
// };

// export default Pagination;

// default
// import React from "react";
// import { PreviousIcon, SkipIcon } from "./IconComponents";

// const Pagination = ({ activePage, totalPages, onPageChange }) => {
//   const isFirstPage = activePage === 1;
//   const isLastPage = activePage === totalPages;

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       onPageChange(page);
//     }
//   };

//   const goToPreviousPage = () => {
//     const previousPage = isFirstPage ? totalPages : activePage - 1;
//     handlePageChange(previousPage);
//   };

//   const goToNextPage = () => {
//     const nextPage = isLastPage ? 1 : activePage + 1;
//     handlePageChange(nextPage);
//   };

//   const renderPageNumbers = () => {
//     const visiblePages = 9; // Number of visible page numbers

//     if (totalPages <= visiblePages) {
//       return Array.from({ length: totalPages }, (_, index) => index + 1);
//     }

//     const ellipsisPage = totalPages - 1;
//     const pageNumbers = Array.from(
//       { length: visiblePages - 1 },
//       (_, index) => index + 1
//     );

//     return [...pageNumbers, "...", ellipsisPage];
//   };

//   return (
//     <ul className="flex items-center justify-center">
//       <li>
//         <button
//           className="flex items-center px-3 py-1 text-disabled text-sm font-normal"
//           onClick={goToPreviousPage}
//           disabled={isFirstPage}
//         >
//           <PreviousIcon className="pe-1 w-3" /> Previous
//         </button>
//       </li>
//       {renderPageNumbers().map((page, index) => (
//         <li key={index}>
//           <button
//             className={`px-3 py-1 ${
//               page === activePage
//                 ? "bg-enabled-btn text-white text-sm font-normal"
//                 : ""
//             }`}
//             onClick={() => handlePageChange(page)}
//           >
//             {page}
//           </button>
//         </li>
//       ))}
//       <li>
//         <button
//           className="flex items-center px-3 py-1 text-enabled-btn text-sm font-normal"
//           onClick={goToNextPage}
//           disabled={isLastPage}
//         >
//           Next <SkipIcon className="ps-1" />
//         </button>
//       </li>
//     </ul>
//   );
// };

// export default Pagination;

// import React from 'react';
// import { PreviousIcon, SkipIcon } from "./IconComponents";
// // import { ChevronLeftIcon, ChevronRightIcon } from './IconComponents';

// const Pagination = ({ activePage, totalPages, onPageChange }) => {
//   const handlePageChange = (pageNumber) => {
//     if (pageNumber >= 1 && pageNumber <= totalPages) {
//       onPageChange(pageNumber);
//     }
//   };

//   return (
//     <div className="px-4 py-3 flex items-center justify-between bg-gray-100 border-t border-neutral-primary sm:px-6">
//       <div className="flex-1 flex justify-between sm:hidden">
//         <button
//           onClick={() => handlePageChange(activePage - 1)}
//           disabled={activePage === 1}
//           className="relative inline-flex items-center px-4 py-2 text-sm font-medium text-disabled  bg-white border border-neutral-primary rounded-md hover:bg-neutral-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-primary"
//         >
//           <span className="sr-only">Previous</span>
//           <PreviousIcon className="h-5 w-5" aria-hidden="true" />
//         </button>
//         <button
//           onClick={() => handlePageChange(activePage + 1)}
//           disabled={activePage === totalPages}
//           className="ml-3 relative inline-flex items-center px-4 py-2 text-sm font-medium text-neutral-primary bg-white border border-neutral-primary rounded-md hover:bg-neutral-light focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-primary"
//         >
//           <span className="sr-only">Next</span>
//           <SkipIcon className="h-5 w-5" aria-hidden="true" />
//         </button>
//       </div>
//       <div className="hidden sm:flex-1 sm:flex sm:items-center sm:justify-between">
//         <div>
//           <p className="text-sm text-neutral-primary">
//             Showing
//             <span className="font-medium mx-1">
//               {(activePage - 1) * 12 + 1}
//             </span>
//             to
//             <span className="font-medium mx-1">
//               {activePage === totalPages
//                 ? totalPages * 12
//                 : activePage * 12}
//             </span>
//             of
//             <span className="font-medium mx-1">{totalPages * 12}</span>
//             results
//           </p>
//         </div>
//         <div>
//           <nav className="relative z-0 inline-flex rounded-md shadow-sm -space-x-px" aria-label="Pagination">
//             <button
//               onClick={() => handlePageChange(activePage - 1)}
//               disabled={activePage === 1}
//               className="relative inline-flex items-center px-2 py-2 rounded-l-md border border-neutral-primary bg-white text-sm font-medium text-neutral-primary hover:bg-neutral-light focus:z-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-primary"
//             >
//               <span className="sr-only">Previous</span>
//               <PreviousIcon className="h-5 w-5" aria-hidden="true" />
//             </button>
//             {[...Array(totalPages)].map((_, index) => {
//               const pageNumber = index + 1;
//               return (
//                 <button
//                   key={pageNumber}
//                   onClick={() => handlePageChange(pageNumber)}
//                   className={`-ml-px relative inline-flex items-center px-4 py-2 border border-neutral-primary bg-white text-sm font-medium ${
//                     pageNumber === activePage
//                       ? 'text-neutral-primary bg-neutral-light'
//                       : 'text-gray-700 hover:bg-gray-50'
//                   } focus:z-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-primary`}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//             <button
//               onClick={() => handlePageChange(activePage + 1)}
//               disabled={activePage === totalPages}
//               className="relative inline-flex items-center px-2 py-2 rounded-r-md border border-neutral-primary bg-white text-sm font-medium text-neutral-primary hover:bg-neutral-light focus:z-10 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-neutral-primary"
//             >
//               <span className="sr-only">Next</span>
//               <SkipIcon className="h-5 w-5" aria-hidden="true" />
//             </button>
//           </nav>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Pagination;

// import React from "react";
// import { PreviousIcon, SkipIcon } from "./IconComponents";

// const Pagination = ({ totalPages, activePage, onPageChange }) => {
//   const isFirstPage = activePage === 1;
//   const isLastPage = activePage === totalPages;

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       onPageChange(page);
//     }
//   };

//   const goToPreviousPage = () => {
//     const previousPage = isFirstPage ? totalPages : activePage - 1;
//     handlePageChange(previousPage);
//   };

//   const goToNextPage = () => {
//     const nextPage = isLastPage ? 1 : activePage + 1;
//     handlePageChange(nextPage);
//   };

//   const renderPageNumbers = () => {
//     const visiblePages = 9; // Number of visible page numbers

//     if (totalPages <= visiblePages) {
//       return Array.from({ length: totalPages }, (_, index) => index + 1);
//     }

//     const ellipsisPage = totalPages - 1;
//     const pageNumbers = Array.from(
//       { length: visiblePages - 1 },
//       (_, index) => index + 1
//     );

//     return [...pageNumbers, "...", ellipsisPage];
//   };

//   return (
//     <ul className="flex items-center justify-center">
//       <li>
//         <button
//           className="flex items-center px-3 py-1 text-disabled text-sm font-normal"
//           onClick={goToPreviousPage}
//           disabled={isFirstPage}
//         >
//           <PreviousIcon className="pe-1 w-3" /> Previous
//         </button>
//       </li>
//       {renderPageNumbers().map((page, index) => (
//         <li key={index}>
//           <button
//             className={`px-3 py-1 ${page === activePage
//                 ? "bg-enabled-btn text-white text-sm font-normal"
//                 : ""
//               }`}
//             onClick={() => handlePageChange(page)}
//           >
//             {page}
//           </button>
//         </li>
//       ))}
//       <li>
//         <button
//           className="flex items-center px-3 py-1 text-enabled-btn text-sm font-normal"
//           onClick={goToNextPage}
//           disabled={isLastPage}
//         >
//           Next <SkipIcon className="ps-1" />
//         </button>
//       </li>
//     </ul>
//   );
// };

// export default Pagination;

// fall back
// import React from "react";
// import { PreviousIcon, SkipIcon } from "./IconComponents";

// const Pagination = ({ totalPages, activePage, onPageChange }) => {
//   const isFirstPage = activePage === 1;
//   const isLastPage = activePage === totalPages;

//   const handlePageChange = (page) => {
//     if (page >= 1 && page <= totalPages) {
//       onPageChange(page);
//     }
//   };

//   const goToPreviousPage = () => {
//     const previousPage = isFirstPage ? totalPages : activePage - 1;
//     handlePageChange(previousPage);
//   };

//   const goToNextPage = () => {
//     const nextPage = isLastPage ? 1 : activePage + 1;
//     handlePageChange(nextPage);
//   };

//   const renderPageNumbers = () => {
//     const visiblePages = 9; // Number of visible page numbers

//     if (totalPages <= visiblePages) {
//       return Array.from({ length: totalPages }, (_, index) => index + 1);
//     }

//     const ellipsisPage = totalPages - 1;
//     const pageNumbers = Array.from(
//       { length: visiblePages - 1 },
//       (_, index) => index + 1
//     );

//     return [...pageNumbers, "...", ellipsisPage];
//   };

//   return (
//     <ul className="flex items-center justify-center">
//       <li>
//         <button
//           className="flex items-center px-3 py-1 text-disabled text-sm font-normal"
//           onClick={goToPreviousPage}
//           disabled={isFirstPage}
//         >
//           <PreviousIcon className="pe-1 w-3" /> Previous
//         </button>
//       </li>
//       {renderPageNumbers().map((page, index) => (
//         <li key={index}>
//           <button
//             className={`px-3 py-1 ${
//               page === activePage
//                 ? "bg-enabled-btn text-white text-sm font-normal"
//                 : ""
//             }`}
//             onClick={() => handlePageChange(page)}
//           >
//             {page}
//           </button>
//         </li>
//       ))}
//       <li>
//         <button
//           className="flex items-center px-3 py-1 text-enabled-btn text-sm font-normal"
//           onClick={goToNextPage}
//           disabled={isLastPage}
//         >
//           Next <SkipIcon className="ps-1" />
//         </button>
//       </li>
//     </ul>
//   );
// };

// export default Pagination;




